import { type UseQueryResult, useQuery } from 'react-query';
import { type TableParamsType } from '../../types/common';
import {
  CommissionService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_CommisionListDto,
} from '../../services/wealthlane-award-services';

const useGetCommissionList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_CommisionListDto | undefined,
  unknown
> => {
  const { filter, sorting, skipCount, maxResultCount } = tableInfo;

  const commissionList = useQuery(
    ['getCommissionList', filter, sorting, skipCount, maxResultCount],
    async () => {
      return await handleRequest(
        CommissionService.getApiAwardApiAppCommissionCommissionList(
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );
  return commissionList;
};

export default useGetCommissionList;
